import styled from 'styled-components';
import { Chip } from '@material-ui/core';
import { lightTheme as theme } from '../../../shared/theme';

export const MainContent = styled.div`
    padding: ${({ $compact }) => ($compact ? '0' : '24px 32px')};

    @media (max-width: 768px) {
        padding: ${({ $compact }) => ($compact ? '0' : '16px')};
    }
`;

export const ProductChipsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
`;

export const ProductChip = styled(Chip)`
    border-radius: 10px;
    background-color: ${theme.colors.gray100};
    color: ${theme.colors.textSecondary};
    height: 22px;
    font-size: 0.72rem;
`;

export const ProductOverflowChip = styled(Chip)`
    border-radius: 10px;
    background-color: ${theme.colors.gray200};
    color: ${theme.colors.textSecondary};
    height: 22px;
    font-size: 0.72rem;
    font-weight: 700;
    cursor: help;
`;

export const TooltipProductsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px;
`;

export const ActionsCell = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ViewModeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    border-left: 1px solid ${theme.colors.border};
    padding-left: 16px;
`;

export const ViewModeLabel = styled.span`
    font-size: 10px;
    font-weight: 700;
    color: ${theme.colors.textMuted};
    text-transform: uppercase;
`;
